import React from 'react';

/**
 * Renders interest track names for a screening slot.
 * Expects pre-resolved track objects (each with a `name` field),
 * as returned by resolveFromInitial for dateTime[].interestTrack.
 * Shows the first track name and a "+ More" tooltip for additional ones.
 *
 * @param {Object[]} resolvedTracks - pre-resolved interest track objects (each has { name, ... })
 * @returns {JSX.Element|string}
 */
export function renderInterestTracks(resolvedTracks) {
    const tracks = (resolvedTracks || []).filter(Boolean);

    if (tracks.length === 0) return '-';

    return (
        <>
            {tracks[0].name}
            {tracks.length > 1 && (
                <>
                    <span>+ More</span>
                    <div className="tooltip_box">
                        {tracks.map((t, i) => <span key={i}>{t.name}</span>)}
                    </div>
                </>
            )}
        </>
    );
}
